import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "react-hot-toast";
import { rotateWebhookSecret } from "../../api/apiWebhooks";
import parseError from "../../utils/parseError";

export const useRotateWebhookSecret = () => {
    const queryClient = useQueryClient();

    const { mutate: rotateSecretMutate, mutateAsync: rotateSecretAsync, isPending: isRotating } = useMutation({
        mutationFn: rotateWebhookSecret,
        onSuccess: (res) => {
            toast.success(res?.message || "Webhook secret rotated");
            queryClient.invalidateQueries({ queryKey: ["webhooks"] });
        },
        onError: (error) => {
            toast.error(parseError(error) || "Failed to rotate secret");
        },
    });

    return { rotateSecretMutate, rotateSecretAsync, isRotating };
};
